import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FlightsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.6929 20.7515L11.992 13.7036L8.30715 17.3885L8.64506 19.7538L7.64743 20.7515L5.95788 17.7425L2.96497 16.069L3.9626 15.0714L6.29579 15.3771L9.98061 11.6923L2.96497 8.02354L4.28442 6.70408L12.9896 8.68326L16.6744 4.99844C16.9533 4.71953 17.2859 4.58008 17.6721 4.58008C18.0583 4.58008 18.3962 4.7249 18.6858 5.01453C18.9754 5.30417 19.1176 5.6394 19.1122 6.02022C19.1068 6.40104 18.9647 6.7309 18.6858 7.00981L15.001 10.6946L17.0123 19.432L15.6929 20.7515Z'
        />
    ),
})

FlightsIcon.displayName = 'FlightsIcon'
